let variantOptions = []
let isDragging = false;
let globalDragging = false;
let startPos = 0;
let currentScrollPos = 0;



document.addEventListener("DOMContentLoaded", async () => {

    postLoad();
});


const removeActiveFromAllThumbnails = () => {
    const thumbnails = document.querySelectorAll(".image-gallery-thumbnail");
    thumbnails.forEach((thumbnail) => {
        thumbnail.removeAttribute("data-active");
    });
}

const postLoad = () => {
    // has thumbnails
    const productThumbnails = document.querySelector("#thumbnailImages");
    if(productThumbnails){

        // thumbnailImages.style.maxHeight = `${document.querySelector("#productFeaturedImage").offsetHeight - 60}px`;
        // thumbnailImages.style.maxWidth = `${document.querySelector("#productFeaturedImage").offsetWidth}px`;
        dragThumbnails();

        productThumbnails.querySelectorAll(`.image-gallery-thumbnail`).forEach((thumbnail) => {
            thumbnail.addEventListener("click", (event) => {
                console.log('dsfdf', thumbnail);
               event.preventDefault();
                const featuredImage = document.querySelector(`#productFeaturedImage`);
                const mediaType = thumbnail.dataset.type;
                const videoPlayer = document.querySelector(`#gallery-video-player`);

                if(!isDragging){
                    removeActiveFromAllThumbnails();
                    if(mediaType == 'image') {
                        featuredImage.classList.remove('twcss-hidden');
                        featuredImage.src = thumbnail.firstElementChild.dataset.mainsrc;
                        videoPlayer.classList.add('twcss-hidden');
                    } else if (mediaType == 'video') {                        
                        videoPlayer.innerHTML = `
                            <iframe
                                data-image-id="{{ forloop.index }}" 
                                class="twcss-w-full twcss-h-full"
                                width="100%" height="100%" src="${ thumbnail.dataset.url }" frameborder="0" allowfullscreen
                            ></iframe>
                        `;
                        featuredImage.classList.add('twcss-hidden');
                        videoPlayer.classList.remove('twcss-hidden');
                    }
                    thumbnail.setAttribute("data-active", "");
                }
                updateSliderCount();
            }); 


            // mobile touch
            thumbnail.addEventListener("touchstart", () => {

                //wait 85ms to see if user is dragging

                setTimeout(() => {
                    if(!globalDragging){
                        const mainImage = document.querySelector(`#productFeaturedImage`);
                        removeActiveFromAllThumbnails();
                        mainImage.src = thumbnail.firstElementChild.dataset.mainsrc;
                        thumbnail.setAttribute("data-active", "");
                    }
                }, 85);

            });
        });

        updateCurrentSlideCount();

        thumbnailImages.style.opacity = "1";
    }

    const containsSwatches = document.querySelector(".variant-swatch--color");
    if(containsSwatches){
        swatchSelect(document.querySelector(`.variant-swatch--color`));
    }
}


const findVariant = (options) => {

    let variant = Window.ProductData.variants.filter((variant) => {
        return variant.title.toLowerCase() == options.join(" / ");
    });

    let matchingVariant = variant[0];

    if(matchingVariant){
        let compareAtPrice = document.querySelectorAll(`.product-compare-price`);

        compareAtPrice.forEach((price) => {

            if(matchingVariant.compare_at_price != null){
                price.innerHTML = `£${(matchingVariant.compare_at_price / 100).toFixed(2)}`;
            } else {
                price.innerHTML = `£${(matchingVariant.price / 100).toFixed(2)}`;
            }

        });

        if(matchingVariant.compare_at_price != null){
            let crossedOutPrice = document.querySelector(`.price-crossed`);

            crossedOutPrice.innerHTML = `£${(matchingVariant.price / 100).toFixed(2)}`;
        }else{
            let price = document.querySelector(`.product-price`);
            price.innerHTML = `£${(matchingVariant.price / 100).toFixed(2)}`;
        }

        if(matchingVariant.compare_at_price != null){

            let percent = `${(-(1 - (matchingVariant.compare_at_price  / matchingVariant.price)) * 100).toFixed(0)}`;
            if( document.querySelector(`.percentDiff`)){

                document.querySelector(`.percentDiff`).style.display = "twcss-inline-block";
                document.querySelector(`.percentDiff`).innerHTML = `${percent}%`;

                const productImageSale = document.querySelector(`#productImageSale`);
                productImageSale.style.display = "block";
                productImageSale.querySelector("span").innerHTML = `${percent}%`;

            }
        }else if(document.querySelector(`#productImageSale`) != null) {
            const productImageSale = document.querySelector(`#productImageSale`);
            productImageSale.style.display = "none";
        }

        let productAvailable = document.querySelector(`#productAvailable`);
        let productUnavailable = document.querySelector(`#productUnavailable`);
        let inStockLabel = document.querySelector(`#inStockLabel`);
        let mainImageStockLabel = document.querySelector(`#mainImageStockLabel`);

        // check variants in stock
        if(matchingVariant.available){
            document.querySelector(`#productAvailable`).style.display = "block";
            document.querySelector(`#productUnavailable`).style.display = "none";
            document.querySelector(`#inStockLabel`).style.display = "block";
            if (mainImageStockLabel){
                mainImageStockLabel.style.display = "none";
            }
        }else{
            document.querySelector(`#productAvailable`).style.display = "none";
            document.querySelector(`#productUnavailable`).style.display = "block";
            document.querySelector(`#inStockLabel`).style.display = "none";
            if (mainImageStockLabel){
                mainImageStockLabel.style.display = "block";
            }
        }

        let addToCartButton = document.querySelector(`.product__atc`);
        let checkoutButton = document.querySelector(`.product__checkout`);

        addToCartButton.dataset.variantid = matchingVariant.id;
        checkoutButton.dataset.variantid = matchingVariant.id;

        updateMainImage(matchingVariant);

        return variant;
    } else {

    }
}


const updateMainImage = (matchingVariant) => {
    let galleryThumbnails = document.querySelectorAll(`.image-gallery-thumbnail`);
    if(matchingVariant.featured_image != null) {
        const newImagePosition = matchingVariant.featured_image.position;
        let activeImage;
        galleryThumbnails.forEach((thumbnail) => {
            if(thumbnail.dataset.position == newImagePosition){
                thumbnail.setAttribute("data-active", "");
                activeImage = thumbnail;
            } else {
                thumbnail.removeAttribute("data-active", "");
            }
        });

        updateCurrentSlideCount();

        //Scroll to active image
        activeImage.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
        })

        let mainImage = document.querySelector(`#productFeaturedImage`);
        mainImage.src = matchingVariant.featured_image.src;
        mainImage.alt = matchingVariant.featured_image.alt;
    } 

    // galleryThumbnails.forEach((thumbnail) => {
    //     removeActiveFromAllThumbnails();
    //     if(thumbnail.src == matchingVariant.featured_image.src){
    //         thumbnail.setAttribute("data-active", "");
    //         thumbnail.scrollIntoView({
    //             behavior: "smooth",
    //         });
    //     }
    // });

}

const isElementVisibleInContainer = (el, container, direction) => {
    const { top, bottom } = el.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    switch (direction) {
        case 'up':
            return top >= containerRect.top;
        case 'down':
            return bottom <= containerRect.bottom;
        default: // check both directions if no specific direction is given
            return top >= containerRect.top && bottom <= containerRect.bottom;
    }
};

const smoothScrollToElement = (container, target) => {
    if (!container || !target) return;

    const isVertical = window.innerWidth > 1100

    if (isVertical) {
        container.scroll({
            top: target.offsetTop - 20,
            behavior: 'smooth'
        });
    } else {
        container.scroll({
            left: target.offsetLeft - 20,
            behavior: 'smooth'
        });
    }
}

const updateSliderCount = () => {
    const thumbnailSlider = document.getElementById('thumbnailImages');
    const currentSlideCounter = document.querySelector('.current-slide');
    let activeThumb = thumbnailSlider.querySelector(".image-gallery-thumbnail[data-active]");
    currentSlideCounter.textContent = activeThumb.dataset.position;
}

const updateCurrentSlideCount = (activeSlide) => {
    let galleryThumbnails = document.querySelectorAll(`.image-gallery-thumbnail`);
    let currentSlide = document.querySelector(`.current-slide`);
    // get the index of the active slide and set the counter to that index

    for (let i = 0; i < galleryThumbnails.length; i++) {
        let thumbnail = galleryThumbnails[i];
        if(thumbnail.dataset.active){
            currentSlide.innerText = `${i + 1}`;
        }
    }
}


const dragThumbnails = () => {

    const thumbSliderUp = document.querySelectorAll(".thumbSliderUp");
    const thumbSliderDown = document.querySelectorAll(".thumbSliderDown");
    const thumbnailImages = document.getElementById("thumbnailImages");
    const thumbnailImageHeight = thumbnailImages.querySelector(".image-gallery-thumbnail").offsetHeight;
    const thumbnailSlider = document.getElementById('thumbnailImages');

    let isDragging = false;
    let startPosX, startPosY, currentScrollPos, currentScrollPosX;

    thumbnailSlider.addEventListener('mousedown', function(e) {
        isDragging = true;
        globalDragging = true;
        startPosX = e.clientX;
        startPosY = e.clientY;
        currentScrollPosX = thumbnailSlider.scrollLeft;
        currentScrollPos = thumbnailSlider.scrollTop;
        e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        let distanceMovedX = e.clientX - startPosX;
        let distanceMovedY = e.clientY - startPosY;

        if (window.innerWidth <= 1100) {
            thumbnailSlider.scrollLeft = currentScrollPosX - distanceMovedX;
        } else {
            thumbnailSlider.scrollTop = currentScrollPos - distanceMovedY;
        }
    });

    document.addEventListener('mouseup', function() {
        isDragging = false;
    });

    thumbnailSlider.addEventListener('touchstart', function(e) {
        isDragging = true;
        globalDragging = true;
        startPosX = e.touches[0].clientX;
        startPosY = e.touches[0].clientY;
        currentScrollPosX = thumbnailSlider.scrollLeft;
        currentScrollPos = thumbnailSlider.scrollTop;
        e.preventDefault();
    }, { passive: false });

    document.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        let distanceMovedX = e.touches[0].clientX - startPosX;
        let distanceMovedY = e.touches[0].clientY - startPosY;

        if (window.innerWidth <= 1100) {
            thumbnailSlider.scrollLeft = currentScrollPosX - distanceMovedX;
        } else {
            thumbnailSlider.scrollTop = currentScrollPos - distanceMovedY;
        }
    }, { passive: false });

    document.addEventListener('touchend', function() {
        isDragging = false;
        globalDragging = false;
    });


    thumbSliderUp.forEach((arrowUp) => {
        arrowUp.addEventListener("click", function () {
            let activeThumb = thumbnailSlider.querySelector(".image-gallery-thumbnail[data-active]");
            if(activeThumb.previousElementSibling){
    
                smoothScrollToElement(thumbnailSlider.querySelector('#thumbnailContaniner'), activeThumb.previousElementSibling);
                if(window.innerWidth > 600){
                    activeThumb.previousElementSibling.scrollIntoView({
                        behavior: "smooth",
                        block: "end",
                        inline: "nearest",
                    });
                }
                removeActiveFromAllThumbnails();
    
                activeThumb.previousElementSibling.setAttribute("data-active", "");
                activeThumb.previousElementSibling.click();
                updateSliderCount();
            }
        });
    });

    thumbSliderDown.forEach((arrowDown) => {
        arrowDown.addEventListener("click", function () {
            let activeThumb = thumbnailSlider.querySelector(".image-gallery-thumbnail[data-active]");
            if(activeThumb.nextElementSibling){
                activeThumb.nextElementSibling.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                    inline: "nearest",
                });
    
                smoothScrollToElement(thumbnailSlider.querySelector('#thumbnailContaniner'), activeThumb.nextElementSibling);
    
                removeActiveFromAllThumbnails();
    
                activeThumb.nextElementSibling.setAttribute("data-active", "");
                activeThumb.nextElementSibling.click();
                updateSliderCount();
            }
        });
    })
} 

// //resize event
// window.addEventListener("resize", () => {
//     const productThumbnails = document.querySelector("#thumbnailImages");

//     if(productThumbnails){

//         thumbnailImages.style.maxHeight = `${document.querySelector("#productFeaturedImage").offsetHeight}px`;
//         thumbnailImages.style.maxWidth = `${document.querySelector("#productFeaturedImage").offsetWidth}px`;

//     }
// });